module.exports = __webpack_public_path__ + "static/media/10.e26fb08a.jpg";